import { Box, styled } from '@mui/material';

const ViewPanelContainer = styled(Box, {
  name: 'view-panel-container',
  slot: 'Root',
})(({ theme }) => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  border: `1px solid ${theme.palette.divider}`,
  flex: '0 0 40%',
  overflow: 'hidden',
}));

const ViewHeaderContainer = styled(Box, {
  name: 'view-header-container',
  slot: 'Root',
})(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '8px',
  borderBottom: '1px solid #E0E0E0',
}));

const ViewHeaderLabelContainer = styled(Box, {
  name: 'view-header-label-container',
  slot: 'Root',
})(() => ({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  alignItems: 'center',
  gap: '8px',
  padding: '8px',
}));

const ViewPanelContentContainer = styled(Box, {
  name: 'view-panel-content-container',
  slot: 'Root',
})(() => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  overflow: 'auto',
  gap: '8px',
}));

export {
  ViewHeaderContainer,
  ViewHeaderLabelContainer,
  ViewPanelContainer,
  ViewPanelContentContainer,
};
